import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Table } from 'primeng/table';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { UsuarioPermissaoEmpresaService } from 'src/app/admihair/service/usuario-permissao-empresa.service';
import { UsuarioPermissaoEmpresa } from 'src/app/admihair/api/dto/usuario-permissao-empresa';


@Component({
  selector: 'app-empresa-detalhar',
  templateUrl: './empresa-detalhar.component.html',
  styleUrls: ['./empresa-detalhar.component.scss']
})
export class EmpresaDetalharComponent implements OnInit {

  constructor(private empresaService: EmpresaService,
    private usuarioService: UsuarioService,
    private usuarioPermissaoEmpresaService: UsuarioPermissaoEmpresaService,
    private activatedRouter: ActivatedRoute, 
    private _router: Router
  ) { }

  id?: number;
  empresa?: Empresa;
  usuarioSelecionado?: Usuario = {};
  usuarios: Usuario[] = [];
  usuariosPermissoesEmpresas: UsuarioPermissaoEmpresa[] = [];
  loading: boolean = false;
  exibirListaPermissoesUsuario: boolean = false;
  idPlanoContaEmpresa?: number;
  eventoAbaTributacao: string = 'LISTAR';
  eventoAbaPlanoConta: string = 'LISTAR';
  eventoAbaUsuario: string = 'LISTAR';

  @ViewChild('filter') filter!: ElementRef;


  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregarEmpresaPorId();
    this.carregarUsuariosEmpresas();
  }

  carregarIdUrl(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }    
  }

  carregarUsuariosEmpresas(){
    this.usuarioService.listarPorEmpresaId(this.id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  carregarEmpresaPorId(){
    this.empresaService.buscarPorId(this.id).subscribe({
      next: (data: Empresa) => {
        this.empresa = data;
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }

  listarPermissaoUsuario(usuario: Usuario){
    this.exibirListaPermissoesUsuario = true;
    this.usuarioSelecionado = usuario;
    this.listarUsuariosPermissoesPorUsuarioEEmpresa();
  }

  listarUsuariosPermissoesPorUsuarioEEmpresa(){
    this.usuarioPermissaoEmpresaService.listarPorUsuarioEEmpresa(this.usuarioSelecionado?.id, this.id).subscribe({
      next: (data: UsuarioPermissaoEmpresa[]) => {
        this.usuariosPermissoesEmpresas = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  abaSelecionada(evento: any) {
    this.eventoAbaUsuario = 'LISTAR';
    this.eventoAbaPlanoConta = 'LISTAR';
    this.eventoAbaTributacao = 'LISTAR';
  }

  voltar(){
    if(this.exibirListaPermissoesUsuario){
      this.exibirListaPermissoesUsuario = false;
    } else {
      this._router.navigate(["/rfarias/empresa"], { relativeTo: this.activatedRouter });
    }
  }

  trocarComponentePlanoConta(event: any){
    this.eventoAbaPlanoConta = event.modo;
    this.idPlanoContaEmpresa = event.id;
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
